.rnadomCLass {
  background-color: 'red' !important;
}

.custom-modal {
  .modal-header {
    border: none;
  }
}
